<template>
    <div class="content" v-if="show">
        <div class="mask"></div>
        <div class="box">
            <div class="box-top">
                <span class="box-title">告警信息列表</span>
                <div class="top-btn">
                    <img alt src="../../assets/img/common/close.png"  @click="close"/>
                </div>
            </div>
            
            <div class="box-content">
                <div class="v1">
                    <div class="v101">
                        <span>告警时间：</span>
                        <el-date-picker v-model="value2" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="截止日期" format="yyyy-MM-dd" style="width: 260px;">
                        </el-date-picker>
                        <span style="margin-left: 10px;">状态：</span>
                        <el-select v-model="statType.value" placeholder="请选择" style="width: 100px; margin-right: 10px; user-select: none;">
                            <el-option v-for="item in statType.list" :key="item.value" :label="item.label" :value="item.value" style="user-select: none;"></el-option>
                        </el-select>
                        <span style="margin-left: 10px;">船舶：</span>
                        <el-select v-model="currShip" value-key="id" filterable placeholder="请选择船名" style="width: 160px;" @change="eventChangeShip" clearable>
                            <el-option v-for="item in shipList" :key="item.id" :label="item.name" :value="item"></el-option>
                        </el-select>
                    </div>
                    <div class="v102">
                        <span class="btn1" @click="queryDataList">查询</span>
                    </div>
                </div>
                <div class="box-table">
                    <el-table :data="dataList" stripe style="width: 100%" highlight-current-row class="custom-table">
                        <el-table-column type="index" label="序号" width="50" align="center"/>
                        <el-table-column prop="warnTime" label="告警时间" width="130" align="center"/>
                        <el-table-column prop="warnContent" label="告警内容" width="330" :show-overflow-tooltip="true"/>
                        <el-table-column label="告警截图" width="80" align="center">
                            <template slot-scope="scope">
                                <!-- 告警截图、小视频的 类型值大于100 -->
                                <span class="btn" v-if="scope.row.warnType>100 && scope.row.warnPicture" @click="operate('lookup', scope.row)">查看</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="状态" width="80" align="center">
                            <template slot-scope="scope">
                                <span style="color: #b28501;" v-if="scope.row.handleState==0">待处理</span>
                                <span style="color: green;" v-else-if="scope.row.handleState==1">已处理</span>
                                <span style="color: orange;" v-else-if="scope.row.handleState==2">误报</span>
                                <span style="color: red;" v-else-if="scope.row.handleState==3">稍后处理</span>
                                <span style="color: red;" v-else>未知</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="operator" label="处理人" width="80" align="center" :show-overflow-tooltip="true"/>
                        <el-table-column prop="handleRemark" label="备注" width="80" align="center" :show-overflow-tooltip="true"/>
                        <el-table-column label="操作" width="182" align="center">
                            <template slot-scope="scope">
                                <span class="btn" @click="operate('handle', scope.row)" title="处理">处理</span>
                                <span class="btn" @click="operate('detail', scope.row)" title="详情">详情</span>
                                <span class="btn" @click="operate('del', scope.row.id)" title="删除">删除</span>
                                <span class="btn" @click="showWarnTips(scope.row.warnContent)" title="显示告警">显示告警</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination background layout="total, prev, pager, next"
                        :total="total"
                        @current-change="handleCurrentChange"
                        style="text-align: center; margin-top: 10px; margin-bottom: 10px;">
                    </el-pagination>
                </div>

                <div>
                    <!-- 456 -->
                </div>

            </div>
        </div>

        <!--弹框操作-->
        <SswgModal :visible.sync="modalVisible" :modalTitle="modalTitle" :openFooter="openFooter" @sure="sure">
            <div class="box-content" v-if="currOperation=='del'">
                确认要删除此告警信息吗?
            </div>
            <div class="warn-detail" v-else-if="currOperation=='detail'">
                <ul>
                    <li>
                        <label>告警时间</label>
                        <span>{{ currWarn.warnTime }}</span>
                    </li>
                    <li>
                        <label>告警内容</label>
                        <span>{{ currWarn.warnContent }}</span>
                    </li>
                    <li>
                        <label>AIS信息</label>
                        <span>{{ warnAisInfo }}</span>
                    </li>
                    <li>
                        <label>状态</label>
                        <span>{{ convertState(currWarn.handleState) }}</span>
                    </li>
                    <li>
                        <label>处理人</label>
                        <span>{{ currWarn.operator }}</span>
                    </li>
                    <li>
                        <label>处理时间</label>
                        <span>{{ currWarn.operateTime }}</span>
                    </li>
                    <li>
                        <label>处理备注</label>
                        <span>{{ currWarn.handleRemark }}</span>
                    </li>
                </ul>
            </div>
            <div class="warn-handle" v-else-if="currOperation=='handle'">
                <el-form ref="dgForm" :model="dgForm" label-width="80px">
                    <el-form-item label="告警内容">
                        <span>{{ dgForm.warnContent }}</span>
                    </el-form-item>
                    <el-form-item label="AIS信息">
                        <span>{{ warnAisInfo }}</span>
                    </el-form-item>
                    <el-form-item label="状态" prop="handleState">
                        <el-radio-group v-model="dgForm.handleState" @change="checkedHandleState">
                            <el-radio :label="1">已处理</el-radio>
                            <el-radio :label="2">误报</el-radio>
                            <el-radio :label="3">稍后处理</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="暂停告警">
                        <el-input-number size="mini" v-model="dgForm.pauseMinute" :min="0" :max="1440"></el-input-number>
                        <span>(分钟)</span>
                        <br/>
                        <span style="font-size: 12px; color: #ef5c4a;">设置暂停时长后，该船舶在指定时间内不再上报该类型的告警</span>
                    </el-form-item>
                    
                    <el-form-item label="备注">
                        <el-input v-model="dgForm.handleRemark" maxlength="20" show-word-limit/>
                    </el-form-item>
                </el-form>
            </div>
            <div class="warn-lookup" v-else-if="currOperation=='lookup'">
                <div class="warn-lookup-content" style="border: none;">{{ warnAisInfo }}</div>
                <div class="warn-lookup-content">{{ currWarn.warnContent }}</div>
                <div class="warn-lookup-pic" v-if="warnImg">
                    <el-image :src="warnImg" fit="scale-down" style="height: 400px;">
                        <div slot="error" class="image-slot" style="width: 700px; height: 400px; background-color: #f2f2f2; text-align: center; padding-top: 180px">
                            <i class="el-icon-picture-outline" style="font-size: 50px; color: gray;"></i>
                        </div>
                    </el-image>
                </div>
                <div class="btn-play" v-if="showBtnPlay">
                    <i class="el-icon-video-play" style="font-size: 80px; " @click="playVideo"></i>
                </div>
                <span class="btn-download" v-if="showBtnPlay" @click="downloadVideo">
                    下载视频文件
                </span>

                <span class="btn-download" style="margin-top: 40px;"  @click="downloadWarnImg">
                    下载告警图片
                </span>
            </div>
        </SswgModal>

        <SswgModal :visible.sync="modalVisibleVideo" modalTitle="播放视频文件">
            <div id="player_box1" style="width: 890px; height: 500px; background-color: #29313b;">
            </div>
        </SswgModal>

    </div>
</template>

<script>
import EasyPlayerPro from '../../../public/EasyPlayer-pro'
import { downloadFile } from '../../utils/sswgsz'
export default {
    inject: ['app'],
    components: {
        EasyPlayerPro
    },
    data() {
        return {
            dataList: [],
            total: 0,
            q: {
                agentId: '',
                currentPage: 1,
                pageSize: 10
            },
            centerDialogVisible: true,

            shipList: [],
            currShipId: '',
            currShip: {},

            canSerach: true,

            // value2: [new Date(), new Date()],
            value2: [],
            statType: {
                list: [
                    { value: '', label: '全部' },
                    { value: '0', label: '待处理' },
                    { value: '1', label: '已处理' },
                    { value: '2', label: '误报' }
                ],
                value: ''
            },

            modalVisible: false,
            modalTitle: '',
            currOperation: '',             // del:删除 detail:详情 handle:处理
            currWarnId: 0,
            openFooter: false,

            currWarn: {},
            warnAisInfo: '', // 告警AIS信息
            warnImg: '', // 告警图片
            showBtnPlay: false,            // 是否显示播放视频按钮
            dgForm: {
                handleState: 0,
                pauseMinute: 0,
                handleRemark: '',
            },
            dgRules: {
                reason: [
                    { required: true, message: '必填项', trigger: 'blur' }
                ],
            },

            // 当前视频文件地址 
            currVideoUrl: '',
            // 实际播放的文件地址 http://127.0.0.1:9977/resource/video/20250113101808.mp4
            videoUrl: '', 
            modalVisibleVideo: false,

            currPlayer: null

        }
    },
    computed: {
        hasLogin(){
            return this.$store.state.hasLogin
        },
        show(){
            return this.$store.state.showWarnList
        }
    },
    watch: {
        show(newVal, oldVal){
            if(newVal){
                this.resetForm()
                this.shipList = this.app.shipList
            }
        }
    },
    mounted(){
        
    },
    methods: {

        playCreate() {
            if(this.currPlayer){
                this.currPlayer.destroy()
                this.currPlayer = null
            }
            var container = document.getElementById('player_box1');
            var easyplayer = new EasyPlayerPro(container, {
                isLive: false,//默认 true 
                bufferTime: 0.2, // 缓存时长
                isMute: false,
                stretch: false,
                hasAudio: false,
            });
            easyplayer.on("fullscreen", function (flag) {
                console.log('is fullscreen', flag)
            })

            easyplayer.on("error", function (err) {
                console.log('播放出错', err)
            })
            this.currPlayer = easyplayer
        },

        onPlayer() {
            setTimeout((url) => {
                this.currPlayer && this.currPlayer.playback(url).then(() => {

                }).catch((e) => {
                    console.error(e);
                 });
            }, 0, this.videoUrl)
        },

        // 下载视频文件
        downloadVideo(){
            this.$message.warning('下载中，请稍等...')
            let warnTime = this.parseTime(this.currWarn.warnTime, '{y}{m}{d}{h}{i}{s}')
            downloadFile(this.currVideoUrl, '告警视频'+warnTime).then(res=>{
                console.log(res)
                if(res.status==0){
                    // this.$message.success('下载成功')
                }else{
                    this.$message.error('下载视频文件出错')
                }
            })
        },

        // 下载告警图片
        downloadWarnImg(){
            this.$message.warning('下载中，请稍等...')
            let warnTime = this.parseTime(this.currWarn.warnTime, '{y}{m}{d}{h}{i}{s}')
            const num = Math.floor(Math.random() * 10000) + 1;
            downloadFile(this.warnImg, '告警图片'+warnTime+'-'+num+'.png').then(res=>{
                console.log(res)
                if(res.status==0){
                    // this.$message.success('下载成功')
                }else{
                    this.$message.error('下载视频文件出错')
                }
            })
        },

        // 播放视频文件
        playVideo(){
            this.modalVisibleVideo = true
            setTimeout(()=>{
                this.playCreate()

                this.currPlayer.setMute(false)

                this.videoUrl = this.currVideoUrl
                // this.videoUrl = 'http://127.0.0.1:9977/resource/video/video001.mp4'
                this.onPlayer()
            }, 300)
        },

        close(){
            this.$store.commit('updateShowWarnList', false)
        },

        // 根据店铺id查询船舶对象
        convertShipByMerchantId(merchantId){
            let ship = {}
            for(let i=0; i<this.shipList.length; i++){
                if(this.shipList[i].outletsId==merchantId){
                    ship = this.shipList[i]
                    break
                }
            }
            return ship
        },

        // 更新搜索参数
        updateSearchParam(time, merchantId){
            this.$nextTick(() => {
                // 填充时间范围
                this.value2 = time
                // 填充船舶选择
                this.currShip = this.convertShipByMerchantId(merchantId)
                this.queryDataList()
            })
        },

        eventChangeShip(item){
            this.currShipId = item.id
        },

        queryDataList(){
            if(this.currShip){
                this.q.outletsid = this.currShip.outletsId
            }else{
                this.q.outletsid = undefined
            }

            this.q.agentId = localStorage.getItem('login_agent_id')
            this.q.handleState = this.statType.value?this.statType.value:undefined
            if(this.value2 && this.value2.length>0){
                this.q.beginTime = this.parseTime(this.value2[0])
                this.q.endTime = this.parseTime(this.value2[1])
            }else{
                this.q.beginTime = undefined
                this.q.endTime = undefined
            }
            // console.log(this.q)
            this.sswgPost('/warn/fetchWarnListPage', this.q).then(res => {
                this.dataList = res.data.records
                this.total = res.data.total
                if(this.total<=this.q.pageSize){
                    this.q.currentPage = 1
                }
            }).catch(err => {
                this.$store.commit('logout')
            })
        },

        handleCurrentChange(val){
            this.q.currentPage = val
            this.queryDataList()
        },

        resetForm(){
            this.q.currentPage = 1
            this.q.pageSize = 10
            this.q.handleState = undefined
            this.q.beginTime = undefined
            this.q.endTime = undefined
            this.dataList = []

            this.value2 = []
            this.statType.value = ''
        },

        convertState(state){
            let str = ''
            if(state==0){
                str = '待处理'
            }else if(state==1){
                str = '已处理'
            }else if(state==2){
                str = '误报'
            }else if(state==3){
                str = '稍后处理'
            }
            return str
        },

        checkedHandleState(v){
            console.log(v)
        },

        operate(oper, data){
            console.log(data)
            this.currOperation = oper
            this.modalVisible = true
            this.warnAisInfo = this.formatAisInfo(data)
            if(oper=='del'){
                this.modalTitle = '提示'
                this.openFooter = true
                this.currWarnId = data
            }else if(oper=='detail'){
                this.modalTitle = '详情'
                this.openFooter = false
                this.currWarn = data
            }else if(oper=='handle'){
                this.modalTitle = '处理'
                this.openFooter = true
                this.dgForm.id = data.id
                this.dgForm.warnContent = data.warnContent
                this.dgForm.handleRemark = data.handleRemark
                this.dgForm.handleState = data.handleState
                this.dgForm.pauseMinute = 0
            }else if(oper=='lookup'){
                this.warnImg = ''
                this.showBtnPlay = false
                this.currVideoUrl = ''
                this.modalTitle = '告警截图'
                this.openFooter = false
                this.currWarn = data
                // 如果有图片，才显示图片区域
                if(data.warnPicture){
                    this.warnImg = this.baseApi + 'alarmImg/' + data.warnPicture
                    if(data.warnVideo){
                        this.showBtnPlay = true
                        this.currVideoUrl = this.baseApi + 'alarmVideo/' + data.warnVideo
                    }
                }
                
            }
        },

        formatAisInfo(warn){
            let str = ''
            if(warn.lat){
                str+= '纬度: '+warn.lat+'  经度: '+warn.lot
            }
            if(warn.shipSpeed){
                str+= '  航速: '+warn.shipSpeed
            }
            if(warn.shipAngle){
                str+= '  航向: '+warn.shipAngle
            }
            // str += ' 航速: 29.35 航向: 356.48'
            return str
        },

        sure(){
            if(this.currOperation=='del'){
                let p = {
                    agentId: localStorage.getItem('login_agent_id'),
                    warnIds: []
                }
                p.warnIds.push(this.currWarnId)
                this.sswgPost('/warn/batchDeleteWarn', p).then(res => {
                    console.log(res)
                    if(res.code==200){
                        this.modalVisible = false
                        this.queryDataList()
                        this.$message.success('删除成功')
                    }else{
                        this.$message.error(res.message)
                    }
                    
                    
                })
            }else if(this.currOperation=='handle'){
                console.log(this.dgForm)
                let p = {
                    id: this.dgForm.id,
                    handleState: this.dgForm.handleState,
                    handleRemark: this.dgForm.handleRemark,
                    operator: localStorage.getItem('login_user_name'),
                    pauseMinute: this.dgForm.pauseMinute
                }
                this.sswgPost('/warn/updateWarnItemHandleState', p).then(res => {
                    if(res.code==200){
                        this.modalVisible = false
                        this.queryDataList()
                        this.$message.success('修改成功')
                    }else{
                        this.$message.error(res.message)
                    }
                })
            }
        },

        showWarnTips(msg){
            this.app.updateShowWarnMsg(msg)
        }
        
    }

}

</script>

<style lang="scss" scoped>
    .content {
        width: 100%;
        height: 100%; 
        position: fixed; 
        z-index: 190; 

        
        .mask {
            width: 100%;
            height: 100%;
            position: fixed;
            left: 0;
            top: 0;
            z-index: 180;
            opacity: 0.4;
            background-color: #74b1d1;
        }
        .box {
            position: fixed;
            left: 50%;
            top: 45%;
            // width: 280px;
            background-color: #0078d7;
            border-radius: 5px;
            transform: translate(-50%,-50%);
            border: 1px solid #5d6359;
            z-index: 210;
            color: #ffffff;
            .box-top {
                height: 32px;
                text-align: center;
                position: relative;
                .box-title {
                    font-weight: bold;
                    line-height: 30px;
                    font-size: 15px;
                    user-select: none;
                }
                .top-btn {
                    position: absolute;
                    right: 5px;
                    top: 5px;
                    user-select: none;
                    img {
                        cursor: pointer;
                    }
                }
            }
            .v1 {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 10px 10px 12px 10px;
                .btn1 {
                    font-size: 14px;
                    height: 24px;
                    line-height: 24px;
                    padding: 4px 10px;
                    background: linear-gradient(to bottom, #8ec8f1, #b9dffb);
                    margin-left: 20px;
                    color: #000;
                    border-radius: 4px;
                    cursor: pointer;
                    user-select: none;
                }
            }
            .box-content {
                border: 1px solid #FFFFFF;
                border-radius: 0 0 4px 4px;
                padding: 4px 4px;
                .box-table {
                    border: 1px solid #000000;
                    background-color: #FFFFFF;
                    min-height: 260px;
                }
            }
           
        }
    }

    .btn {
        color: #1762c3;
        border: 1px solid #0078d7;
        border-radius: 2px;
        padding: 1px 4px;
        background-color: #f0f0f0;
        cursor: pointer;
        font-size: 12px;
        margin-left: 4px;
        user-select: none;
    }
    .btn:hover {
        border: 1px dashed #0a0157;
    }

    .warn-detail {
        padding: 10px;
        ul {
            li {
                display: flex;
                padding: 5px 0;
                label {
                    width: 100px;
                }
                span {
                    width: 390px;
                }
            }
        }
    }

    .warn-handle {
        margin: 2px;
        padding-right: 10px;
        border: 1px solid rgb(180, 178, 178);
        width: 490px;
    }

    .warn-lookup {
        width: 700px;
        position: relative;
        .warn-lookup-content {
            margin: 10px 4px;
            padding: 2px;
            color: #FFFFFF;
            font-size: 16px;
            border: 1px dashed rgb(236, 44, 18);
        }
        .warn-lookup-pic {
            margin: 4px;
            display: flex;
            justify-content: center;
            align-items: center;
            border: 1px dashed rgb(236, 44, 18);
            position: relative;
        }
        .btn-play {
            position: absolute;
            left: 45%;
            top: 45%;
            z-index: 10000;
            color: rgb(177, 176, 176);
            font-weight: bold;
            cursor: pointer;
            i:hover {
                color: #FFFFFF;
            }
        }
        .btn-download {
            position: absolute;
            right: 10px;
            top: 100px;
            color: #FFF;
            border: 1px dashed orange;
            padding: 2px 3px;
            border-radius: 4px;
            cursor: pointer;
        }
        .btn-download:hover {
            border-color: red;
        }

    }

</style>
<style scoped>

    #EasyPlayer >>> .icon-luxiang2 { display: none !important; }
    #EasyPlayer >>> .logo { display: none !important; }

    #player_box1 >>> .easyplayer-loading-logo { display: none !important; }
    #player_box1 >>> .easyplayer-speed { display: none !important; }
    #player_box1 >>> .easyplayer-speed-menu { display: none !important; }

    .custom-table >>> .cell {
        font-size: 12px;
        color: #000000;
        padding: 5px 0px;
    }

    .custom-table >>> th {
        background: url(../../assets/img/common/table_bg.png) left top / 100% 100% no-repeat #1832a8;
    }

    /** 表头样式 */
    .custom-table >>> th.el-table__cell>.cell {
        line-height: 22px;
        padding: 0 0;
        color: #FFFFFF;
        font-weight: 400;
    }

    .custom-table >>> .el-table__cell {
        padding: 0 0;
    }

    /* 修改表格行的鼠标悬停颜色 #86e9f9 */
    .custom-table >>> .el-table__body tr:hover>td.el-table__cell {
        background-color: #d4eaee !important;
    }

    /* 修改表格选中行颜色 */
    .custom-table >>> .el-table__body tr.current-row>td.el-table__cell {
        background-color: #3ebcf6 !important;
    }

    .warn-handle >>> .el-form-item__label {
        color: #FFFFFF;
    }

    .warn-handle >>> .el-radio {
        color: #FFFFFF;
    }

    .warn-handle >>> .el-form-item {
        margin-bottom: 0;
    }

    .warn-handle >>> .el-input__inner {
        height: 28px;
    }

    .warn-handle >>> .el-radio__input.is-checked+.el-radio__label {
        color: #eccf16;
    }

    .v1 >>> .el-radio {
        color: #FFF;
        margin-right: 10px;
    }
    .v1 >>> .el-radio__label {
        padding-left: 4px;
    }
    .v1 >>> .el-radio__input.is-checked+.el-radio__label {
        color: #85e984;
    }

    .v101 >>> .el-date-editor .el-range-input {
        height: 26px;
        background: none;
        font-size: 15px;
        font-weight: bold;
        color: #FFF;
    }

    .v101 >>> .el-date-editor .el-range-separator {
        height: 26px;
        line-height: 26px;
        color: #FFFFFF;
    }

    .v101 >>> input.el-input__inner {
        font-size: 15px;
        font-weight: bold;
        height: 26px;
        line-height: 26px;
        background: none;
        color: #FFFFFF;
    }
    .v101 >>> .el-input__icon {
        line-height: normal;
    }

    .v101 >>> .el-input__inner {
        background: none;
        height: 26px;
        line-height: 26px;
    }

</style>